<template>
  <span v-tooltip.top-center="options">
    <slot></slot>
    {{content }}
    <i class="icon-circle-check"></i>
  </span>
</template>

<script>
import Vue from 'vue'
import VTooltip from 'v-tooltip'

Vue.use(VTooltip)

export default {
  name: 'InfoData',
  props: {
    content: {
      type: String,
      required: true
    }
  },
  computed: {
    options() {
      return {
          content: this.content,
          trigger: 'click, hover'
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/css/patterns.scss';

#my-icon .circle {
  fill:none;
  stroke:$teal;
  stroke-miterlimit:10;
  stroke-width:20px
}

#my-icon .checkmark {
  fill:none;
  stroke:#e0114f;
  stroke-linecap:round;
  stroke-linejoin:round;
  stroke-width:25px
}

#my-icon .checkmark {
  animation: checkmark-animation 1s ease-out forwards;
  stroke-dasharray: 400;
  stroke-dashoffset: 400;
  stroke: #cfd8dc;
  transform-origin: center;
}
@keyframes checkmark-animation {
  40% {
    transform: scale(1);
  }
  55% {
    stroke: #cfd8dc;
    transform: scale(1.2);
  }
  70% {
    transform: scale(1);
  }
  100% {
    stroke-dashoffset: 0;
    transform: scale(1);
    stroke: $teal;
  }
}
</style>
